import { Column, Icon, Row, TagWrapper, Text, useAppPalette } from "@bridgesplit/ui";
import { COPY } from "app/constants";

import { DESKTOP_PADDING, MOBILE_PADDING, NAV_BREAKPOINT, useNavbarHeight } from "../navbar";

// Temporary incident notice. Not dismissible, since it applies for as long as it's up.
export default function TransactionsHaltedBanner() {
    const { height } = useNavbarHeight();
    const { background } = useAppPalette();

    return (
        <Column sx={{ mt: height + "px", mb: -height + "px", background }}>
            <TagWrapper
                sx={{ px: DESKTOP_PADDING, borderRadius: 0, [NAV_BREAKPOINT.below]: { px: MOBILE_PADDING } }}
                color="info"
            >
                <Row spacing={1}>
                    <Text variant="body2" svgColor="info">
                        <Icon type="warning" />
                    </Text>
                    <Text variant="body2">{COPY.APP_TRANSACTIONS_HALTED}</Text>
                </Row>
            </TagWrapper>
        </Column>
    );
}
